// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Aba-z","fadeIn":"Bba-z","delay":"Cba-z","recommendedSizeTooltip":"Dba-z"};